<template>
  <div>
    <div class="bg-white border shadow-lg p-4 lg:p-10 lg:w-9/12 mx-auto rounded-lg">
      <div class="bg-red-200 py-4 px-3 mb-6 lg:mb-12 lg:w-5/12 mx-auto">
        <div class="flex justify-center items-center text-red-600 font-bold text-xs lg:text-sm">
          <VSvgIcon name="alert" width="40" height="40" class="text-red-500 mr-1" />

          {{ $t('preTraining.vision.warning.title') }}
        </div>
      </div>
      <div
        class="mb-6 lg:mb-12 text-lg leading-relaxed"
        v-html="$t('preTraining.vision.warning.content')"
      ></div>
      <div class="mb-4 lg:mb-8 flex justify-center items-center">
        <VFormCheckbox
          :label="$t(`preTraining.vision.warning.checkbox`)"
          labelPosition="right"
          @update="value => markAsChecked()"
        />
      </div>
      <div class="flex justify-center">
        <button class="rounded-full button">
          {{ $t('preTraining.vision.warning.button') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VFormCheckbox from '@/components/base/VFormCheckbox';
import VSvgIcon from '@/components/base/VSvgIcon';
export default {
  components: { VSvgIcon, VFormCheckbox },
  data() {
    return {};
  },
  methods: {
    markAsChecked() {
      console.log('click');
      this.$emit('handleVisionWarning');
    },
  },
  async mounted() {},
};
</script>
